module.exports = __webpack_public_path__ + "img/8_Wir Team Seref MS Mosshammer Bischofshofen.9f12a44b.jpg";